export const getScrollbarSize = () => {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
};
export const getBodyPadding = () => {
    const paddingDirection = (document === null || document === void 0 ? void 0 : document.dir) === 'rtl' ? 'paddingLeft' : 'paddingRight';
    return parseInt(window.getComputedStyle(document.body)[paddingDirection], 10) || 0;
};
//# sourceMappingURL=handleScrollbar.js.map